import { useEffect, useState } from "react";

const QUERY = "(max-width: 767px)";

/** Vrai sous 768 px. Le bureau ne se monte pas dans ce cas. */
export function usePhone(): boolean {
  const [phone, setPhone] = useState(() => window.matchMedia(QUERY).matches);

  useEffect(() => {
    const media = window.matchMedia(QUERY);
    const apply = () => setPhone(media.matches);
    apply();
    media.addEventListener("change", apply);
    return () => media.removeEventListener("change", apply);
  }, []);

  return phone;
}
